import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PendingChangesGuard } from '../dave-data-module/guards/pending-changes.guard';
import { ValidTokenGuard } from '../dave-data-module/guards/valid-token.guard';
import { DetailPersonComponent } from './components/detail-person/detail-person.component';

const routes: Routes = [
    {
        path: 'new',
        data: { breadcrumb: 'Neue Person' },
        component: DetailPersonComponent,
        canActivate: [ValidTokenGuard],
        canActivateChild: [ValidTokenGuard],
        canDeactivate: [PendingChangesGuard],
        resolve: {
            ...DetailPersonComponent.RequiredResolvers,
        },
    },
    {
        path: ':personId',
        data: { breadcrumb: 'personId' },
        component: DetailPersonComponent,
        canActivate: [ValidTokenGuard],
        canActivateChild: [ValidTokenGuard],
        canDeactivate: [PendingChangesGuard],
        resolve: {
            ...DetailPersonComponent.RequiredResolvers,
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
})
export class DavePersonRoutingModule {}
